module.exports = __webpack_public_path__ + "static/media/workingmemory-words-3.31b75aba.mp3";